import React from 'react'
import { useRouter } from 'next/router'
import { subDays } from 'date-fns'

import format from 'date-fns/format'
import isFuture from 'date-fns/is_future'
import isBefore from 'date-fns/is_before'
import { FormattedMessage } from 'react-intl'
import Footer, { Navigation } from '@avcan/crystal/components/footer/Footer'

import ArchiveLayout from 'layouts/map/archive-layout'
import * as Sources from 'layouts/map/sources/context'
import useColumns from 'constants/menus/footer'
import { useArchivedForecasts } from 'hooks/useArchivedForecasts'
import { formatDateForQuery } from 'utils/product'
import { Error } from 'layouts/pages'
import { RouterReady } from 'components/misc/RouterReady'

export const START_DATE_OF_FIXED_FORECAST_REGIONS = '2010-10-15'
export const END_DATE_OF_FIXED_FORECAST_REGIONS = '2022-04-30'
export const START_DATE_OF_FLEXIBLE_FORECAST_REGIONS = '2022-11-01'

export default function ArchiveForecast() {
    return (
        <RouterReady>
            <ArchiveForecastPage />
        </RouterReady>
    )
}

const ArchiveForecastPage = () => {
    const router = useRouter()
    const columns = useColumns()
    const { date } = router.query

    const formattedDate = formatDateForQuery(date)
    const inputDate = format(date)
    const invalidDate =
        isFuture(inputDate) || isBefore(inputDate, format(START_DATE_OF_FLEXIBLE_FORECAST_REGIONS))
    const { metadata, areas } = useArchivedForecasts(formattedDate)

    const data = {
        forecasts: {
            metadata,
            areas,
        },
        weather: {
            stations: null,
        },
        min: {
            reports: null,
        },
        mcr: {
            reports: null,
        },
        accidents: null,
        spaw: {
            area: null, // TODO: connect me to API once available
        },
    }

    if (!formattedDate || invalidDate) {
        return (
            <Error>
                <p>
                    <FormattedMessage
                        defaultMessage="Invalid date"
                        description="Forecast archive error message"
                    />
                </p>
            </Error>
        )
    }

    return (
        <Sources.Provider data={data}>
            <ArchiveLayout />
            <Footer>
                <Navigation columns={columns} />
            </Footer>
        </Sources.Provider>
    )
}
